import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { ApplicationRole } from '../../../shared/src/data/permission/applicationRole'

const availableRoles: ApplicationRole[] = [
  'Company Admin',
  'Office Admin',
  'Office Commenter',
]

export const UserRoleSelector = ({
  selectedRole,
  setSelectedRole,
  disabled,
}: {
  selectedRole: ApplicationRole | undefined
  setSelectedRole: (selectedRole: ApplicationRole) => void
  disabled?: boolean
}) => {
  return (
    <FormControl fullWidth color='secondary'>
      <InputLabel>Role</InputLabel>
      <Select
        disabled={disabled}
        color='secondary'
        value={selectedRole || ''}
        fullWidth
        onChange={(e) => setSelectedRole(e.target.value as ApplicationRole)}
      >
        {availableRoles.map((role) => (
          <MenuItem key={role.replace(' ', '_')} value={role}>
            {role}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
